// extracted by mini-css-extract-plugin
export default {"button":"BaseBackToTop-qrP1O__button"};